import { type ComponentPropsWithRef } from 'react';

import VBaseTableContextProvider from './VBaseTableContextProvider';
import VInnerBaseTable from './VInnerBaseTable';
import type { VBaseTableData, VBaseTableProps } from './type';

const VBaseTable = <T extends VBaseTableData>({
  cellRenderer,
  columnList,
  columnRenderer,
  columnStyleMap,
  copyableColumnList,
  data,
  loading,
  resizable,
  rowClassName,
  rowSize,
  renderEmptyData,
  renderLoadingData,
  onCellClick,
  onCopy,
  onDoubleClick,
  onRowClick,
  onScrollEnd,
  ref,
  ...rest
}: VBaseTableProps<T> &
  Omit<
    ComponentPropsWithRef<'div'>,
    'onClick' | 'onCopy' | 'onDoubleClick' | 'onScrollEnd'
  >) => {
  const props = {
    cellRenderer,
    columnList,
    columnRenderer,
    columnStyleMap,
    copyableColumnList,
    data,
    loading,
    resizable,
    rowSize,
    rowClassName,
    renderEmptyData,
    renderLoadingData,
    onCellClick,
    onCopy,
    onDoubleClick,
    onRowClick,
    onScrollEnd,
  };

  return (
    <VBaseTableContextProvider {...props}>
      <VInnerBaseTable ref={ref} {...rest} />
    </VBaseTableContextProvider>
  );
};

export default VBaseTable;
